import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useHasPermissionToAccessPage } from '../useHasPermissionToAccessPage';
import { useGetUserMe } from '@/api/REST/userMe';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { isTest } from '@/legacy/utils/env';

export const useHasProjectPortfolio = () => {
  const { hasLegacyBillingPlan } = useGetUserMe();
  // We handle permission to Portfolio page via a specific page permission 'DesignSevenSearchProject'
  const { hasPermission, isLoading } = useHasPermissionToAccessPage(
    'DesignSevenSearchProject',
  );
  const featureFlagEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.PROJECT_PORTFOLIO,
  );

  const rollOutEnabled = !isLoading && hasPermission && featureFlagEnabled;

  if (hasLegacyBillingPlan || isTest) {
    return false;
  }

  return rollOutEnabled;
};
